<template>
    <div
        id="contatti"
        class="bg-light"
        :class="{ 'pagina-vetrina': $route.name !== 'gallery-contacts' }"
    >
        <vue-headful
            title="Entra a far parte del mondo Rikorda Eventi"
            description="Richiedi maggiori informazioni ed entra a far parte del mondo Rikorda Eventi!"
        />
        <div class="body-wrapper">
            <gallery-header :header="($route.name === 'gallery-contacts') ? '' : 'LOGIN'" />

            <main class="mt-5">
                <div class="container">
                    <h2 class="mb-0 text-uppercase">{{$t('Contatti')}}</h2>
                    <div
                        v-if="loaded()"
                        class="row align-items-center mt-3"
                    >
                        <div class="col-sm-6">
                            <h3 class="mb-0">{{shop.ragioneSociale}}</h3>
                            <address
                                class="mb-0 mt-1 text-blurikorda"
                                v-if="shop.showAddressAndMap"
                            >
                                <span v-if="shop.indirizzo">{{shop.indirizzo}}</span>
                                <br>
                                <span v-if="shop.cap">{{shop.cap}}</span> -
                                <span v-if="shop.citta">{{shop.citta}}</span>&nbsp;
                                <span v-if="shop.provincia">({{shop.provincia}})</span>
                            </address>
                            <ul class="links-contatti mb-0 mt-3">
                                <li v-if="shop.email">
                                    <span>
                                        <!--{{$t('Mail')}}: --><a :href="`mailto:${shop.email}`">{{shop.email}}</a>
                                    </span>
                                </li>
                                <li v-if="shop.telefono">
                                    <span>
                                        <!--{{$t('Telefono')}}: --><a :href="`tel:${shop.telefono}`">{{shop.telefono}}</a>
                                    </span>
                                </li>
                            </ul>
                            <ul class="links-social mb-0 mt-3 d-flex align-items-center">
                                <li v-if="shop.facebook">
                                    <span>
                                        <!--{{$t('Facebook')}}: --><a :href="shop.facebook"><img src="/images/icons/icon-fb.png" /></a>
                                    </span>
                                </li>
                                <li v-if="shop.instagram">
                                    <span>
                                        <!--{{$t('Instagram')}}: --><a :href="shop.instagram"><img src="/images/icons/icon-ig.png" /></a>
                                    </span>
                                </li>
                            </ul>
                        </div>
                        <div class="col-sm-6 mt-3 mt-sm-0">
                            <google-map-loader
                                v-if="isMapReady && shop.showAddressAndMap"
                                v-bind:shop="shop"
                                class="w-100"
                            />
                        </div>
                    </div>
                </div>
            </main>

            <gallery-footer />
        </div>
    </div>
</template>

<script>
import GoogleMapLoader from "../components/GoogleMapLoader";
import GalleryHeader from "../components/gallery/Header";
import GalleryFooter from "../components/gallery/Footer";
import Gallery from "./backend/Gallery.vue";

export default {
    name: "Contacts",
    components: { GoogleMapLoader, GalleryHeader, GalleryFooter },
    data() {
        return {
            shop: {
                isShop: false,
                showAddressAndMap: false
            },
            isMapReady: false
        };
    },
    mounted() {
        console.debug(this.$route.name);
    },
    computed: {
        logoUrl() {
            return this.storedShopData && this.storedShopData.logoUrl
                ? this.storedShopData.logoUrl
                : "";
        },
        storedShopData() {
            return this.$store.getters.shopData;
        },
        storedShop() {
            return this.storedShopData && this.storedShopData.shop;
        }
    },
    methods: {
        resolveUrl(data) {
            const resolver = this.$router.resolve(data);
            return resolver.resolved.matched.length ? resolver.href : "#";
        },
        loaded() {
            if (this.storedShopData && this.storedShopData.shop) {
                this.shop = this.storedShopData.shop;
                this.isMapReady = true;
                this.shop.isShop = false;
                this.shop.showAddressAndMap =
                    this.storedShopData.shop.visualizzaIndirizzo == "1";
                return true;
            }
            return false;
        }
    }
};
</script>

<style scoped>
.links-social > li:not(:first-child) {
    margin-left: 0.5rem;
}
.links-social > li:not(:last-child) {
    margin-right: 0.5rem;
}
</style>
